var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGuidelinesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.209,
    height: 32.487,
    viewBox: "0 0 33.209 32.487",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-guideline-4892347",
    transform: "translate(-4 -5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46",
    "data-name": "Group 46",
    transform: "translate(4 5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_45",
    "data-name": "Group 45",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3453",
    "data-name": "Path 3453",
    d: "M29.99,31.351a7.4,7.4,0,0,0,0-14.8V7.888a.341.341,0,0,0-.361-.361h-7.58V6.8a.341.341,0,0,0-.361-.361H19.522V5.361A.341.341,0,0,0,19.161,5H15.19a.341.341,0,0,0-.361.361V6.444H12.663A.341.341,0,0,0,12.3,6.8v.722H4.361A.341.341,0,0,0,4,7.888V30.34a3.746,3.746,0,0,0,3.537,3.537h0l22.019,3.61h.072a1.834,1.834,0,0,0,1.8-1.8v-.108c0-.036,0-.036-.036-.072,0-.036-.036-.036-.036-.072a.035.035,0,0,0-.036-.036.126.126,0,0,0-.072-.036c-.036,0-.036-.036-.072-.036h-.036L29.99,35V31.351Zm6.5-7.4a6.678,6.678,0,1,1-6.678-6.678A6.686,6.686,0,0,1,36.487,23.951ZM13.024,7.166H15.19a.341.341,0,0,0,.361-.361V5.722H18.8V6.8a.341.341,0,0,0,.361.361h2.166v1.8h-8.3Zm16.641,29.6L9.306,33.444a4.039,4.039,0,0,0,1.913-3.032l19.492,5.559A1.164,1.164,0,0,1,29.665,36.765Zm-18.7-7.219h-.18c-.036,0-.036,0-.072.036a.035.035,0,0,0-.036.036c-.036,0-.036.036-.072.036l-.036.036c0,.036-.036.036-.036.072v.108a3.054,3.054,0,0,1-2.852,3.249,2.985,2.985,0,0,1-2.96-3.1V8.249H12.3V9.332a.341.341,0,0,0,.361.361h9.024a.341.341,0,0,0,.361-.361V8.249h7.219v8.338a7.382,7.382,0,0,0,0,14.727V34.78Z",
    transform: "translate(-4 -5)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3454",
    "data-name": "Path 3454",
    d: "M60,47.595A5.595,5.595,0,1,0,65.595,42,5.623,5.623,0,0,0,60,47.595Zm10.468,0a4.873,4.873,0,1,1-4.873-4.873A4.9,4.9,0,0,1,70.468,47.595Z",
    transform: "translate(-39.786 -28.644)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3455",
    "data-name": "Path 3455",
    d: "M66.614,53.193a.357.357,0,1,0-.505.505l1.8,1.877a.349.349,0,0,0,.505,0L72.75,51.6a.358.358,0,1,0-.469-.541l-4.115,3.754Z",
    transform: "translate(-43.62 -34.387)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3456",
    "data-name": "Path 3456",
    d: "M12.888,27H10.361a.341.341,0,0,0-.361.361v2.527a.341.341,0,0,0,.361.361h2.527a.341.341,0,0,0,.361-.361V27.361A.341.341,0,0,0,12.888,27Zm-.361,2.527h-1.8v-1.8h1.8Z",
    transform: "translate(-7.834 -19.059)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3457",
    "data-name": "Path 3457",
    d: "M12.888,41H10.361a.341.341,0,0,0-.361.361v2.527a.341.341,0,0,0,.361.361h2.527a.341.341,0,0,0,.361-.361V41.361A.341.341,0,0,0,12.888,41Zm-.361,2.527h-1.8v-1.8h1.8Z",
    transform: "translate(-7.834 -28.005)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3458",
    "data-name": "Path 3458",
    d: "M12.888,55H10.361a.341.341,0,0,0-.361.361v2.527a.341.341,0,0,0,.361.361h2.527a.341.341,0,0,0,.361-.361V55.361A.341.341,0,0,0,12.888,55Zm-.361,2.527h-1.8v-1.8h1.8Z",
    transform: "translate(-7.834 -36.952)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3459",
    "data-name": "Path 3459",
    d: "M23.361,29.722H35.634a.361.361,0,1,0,0-.722H23.361a.361.361,0,1,0,0,.722Z",
    transform: "translate(-16.142 -20.337)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3460",
    "data-name": "Path 3460",
    d: "M23.361,34.722H37.078a.361.361,0,1,0,0-.722H23.361a.361.361,0,1,0,0,.722Z",
    transform: "translate(-16.142 -23.532)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3461",
    "data-name": "Path 3461",
    d: "M23.361,43.722h9.024a.361.361,0,1,0,0-.722H23.361a.361.361,0,1,0,0,.722Z",
    transform: "translate(-16.142 -29.283)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3462",
    "data-name": "Path 3462",
    d: "M33.468,48H23.361a.361.361,0,1,0,0,.722H33.468a.361.361,0,1,0,0-.722Z",
    transform: "translate(-16.142 -32.478)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3463",
    "data-name": "Path 3463",
    d: "M23.361,57.722h9.024a.361.361,0,1,0,0-.722H23.361a.361.361,0,1,0,0,.722Z",
    transform: "translate(-16.142 -38.23)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3464",
    "data-name": "Path 3464",
    d: "M33.468,62H23.361a.361.361,0,1,0,0,.722H33.468a.361.361,0,1,0,0-.722Z",
    transform: "translate(-16.142 -41.425)",
    fill: "#404040"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuidelinesIcon);
export default __webpack_public_path__ + "static/media/guidelines-icon.1ac7f603e54b96e74a9a1e32c8d01069.svg";
export { ForwardRef as ReactComponent };